"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _hooks = require("../../hooks");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props, isTransitionInMotion, isExpanded, isOpenBtnVisible) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    scrollProps = _useStylesUtils.scrollProps;
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    _props$itemHeight = props.itemHeight,
    itemHeight = _props$itemHeight === void 0 ? 0 : _props$itemHeight;
  var ccExpandableListStyle = (0, _react.useMemo)(function () {
    var itemsProps = function itemsProps() {
      var maxHeight = isExpanded ? pxToRem(itemHeight * 3 + 16) : items.length > 0 ? pxToRem(itemHeight + 16) : 0;
      var padding = items.length > 0 ? "".concat(pxToRem(8), " ").concat(pxToRem(16), " ").concat(pxToRem(isTransitionInMotion || isExpanded && !isMobileView ? 40 : 8)) : "0 ".concat(pxToRem(16));
      var marginBottom = items.length > 0 ? pxToRem(10) : 0;
      return {
        maxHeight: maxHeight,
        padding: padding,
        marginBottom: marginBottom
      };
    };
    var expandedProps = function expandedProps() {
      var overflow = isExpanded && !isTransitionInMotion ? 'auto' : 'hidden';
      var maxHeight = isExpanded ? pxToRem(itemHeight * 3) : items.length > 0 ? pxToRem(itemHeight) : 0;
      return {
        overflow: overflow,
        maxHeight: maxHeight
      };
    };
    var openBtnExpandedProps = function openBtnExpandedProps() {
      var marginInlineEnd = isExpanded ? pxToRem(-72) : 0;
      var opacity = isOpenBtnVisible && !isExpanded ? 1 : 0;
      return {
        marginInlineEnd: marginInlineEnd,
        opacity: opacity
      };
    };
    var closeBtnExpandedProps = function closeBtnExpandedProps() {
      var opacity = isExpanded ? 1 : 0;
      return {
        opacity: opacity
      };
    };
    var ccExpandableList = (0, _css.css)(_objectSpread({
      position: 'relative',
      overflow: 'hidden',
      borderRadius: pxToRem(10),
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light,
      transition: '.5s ease-in-out',
      boxSizing: 'content-box'
    }, itemsProps()));
    var ccExpandableListContent = (0, _css.css)({
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%'
    });
    var ccExpandableListItems = (0, _css.css)(_objectSpread(_objectSpread({
      padding: 0,
      margin: 0,
      listStyle: 'none',
      overflow: 'hidden',
      display: 'flex',
      flexWrap: 'wrap',
      transition: '.5s ease-in-out'
    }, expandedProps()), scrollProps()));
    var ccExpandableListItem = (0, _css.css)({
      position: 'relative'
    });
    var ccExpandableListRemoveAll = (0, _css.css)({
      marginInlineStart: pxToRem(8)
    });
    var ccExpandableListOpen = (0, _css.css)(_objectSpread({
      whiteSpace: 'nowrap',
      transition: '0.5s ease-in-out'
    }, openBtnExpandedProps()));
    var ccExpandableListClose = (0, _css.css)(_objectSpread({
      position: 'absolute',
      bottom: pxToRem(12),
      left: '50%',
      transform: 'translateX(-50%)',
      transition: '0.5s ease-in-out'
    }, closeBtnExpandedProps()));
    var ccExpandableListBtn = (0, _css.css)({
      fontWeight: 'bold'
    });
    return {
      ccExpandableList: ccExpandableList,
      ccExpandableListContent: ccExpandableListContent,
      ccExpandableListItems: ccExpandableListItems,
      ccExpandableListItem: ccExpandableListItem,
      ccExpandableListRemoveAll: ccExpandableListRemoveAll,
      ccExpandableListOpen: ccExpandableListOpen,
      ccExpandableListClose: ccExpandableListClose,
      ccExpandableListBtn: ccExpandableListBtn
    };
  }, [isExpanded, isMobileView, isOpenBtnVisible, isTransitionInMotion, itemHeight, items.length, pxToRem, scrollProps, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light]);
  return {
    'cc-ExpandableList': ccExpandableListStyle.ccExpandableList,
    'cc-ExpandableList__content': ccExpandableListStyle.ccExpandableListContent,
    'cc-ExpandableList__items': ccExpandableListStyle.ccExpandableListItems,
    'cc-ExpandableList__item': ccExpandableListStyle.ccExpandableListItem,
    'cc-ExpandableList__remove-all': ccExpandableListStyle.ccExpandableListRemoveAll,
    'cc-ExpandableList__open': ccExpandableListStyle.ccExpandableListOpen,
    'cc-ExpandableList__close': ccExpandableListStyle.ccExpandableListClose,
    'cc-ExpandableList__btn': ccExpandableListStyle.ccExpandableListBtn
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;